import { SubscriptionStatus } from "@/primary-models";

export const DEFAULT_POSSIBLE_DELIVERY_NUMBER_OF_DAYS = 84;

export enum DeliveryDatesOrderType {
  TRIAL = "TRIAL",
  REPEAT = "REPEAT",
}

export const DEFAULT_POSSIBLE_DELIVERY_ORDER_TYPE = DeliveryDatesOrderType.REPEAT;

export type TDeliveryDatesOrderType = (typeof DeliveryDatesOrderType)[keyof typeof DeliveryDatesOrderType];

export interface IPossibleDeliveryDatesQuery {
  noRetry?: boolean;
  numberOfDays?: number;
  /** if set, then only subscriptions in that state will be considered when determining the
   *  subscriptionType and addonPlanType to use when searching for matching rules. */
  subscriptionStatus?: SubscriptionStatus;
  /** The LEGACY RECHARGE subscription IDs for which to return possible delivery dates.
   * If not set, then all subscriptions will be considered. */
  subscriptionId?: number[];
  /** The KATKIN subscription IDs for which to return possible delivery dates.
   * If not set, then all subscriptions will be considered. */
  katkinSubscriptionId?: number[];
  /** should be false in most cases (unless maybe you're an admin), since we want customers to only
   *  be able to choose from non-disabled delivery dates regardless of whether they've been marked as bank
   *  holidays */
  bankHoliday?: boolean;
  orderType?: TDeliveryDatesOrderType;
}

export interface IPossibleDeliveryDate {
  /** YYYY-MM-DD */
  date: string;
  price: 0;
}

export interface IPossibleDeliveryDatesResponse {
  dates: IPossibleDeliveryDate[];
  currentDeliveryDate?: IPossibleDeliveryDate;
  soonestDeliveryDate: IPossibleDeliveryDate;
  oneWeekDeliveryDate?: IPossibleDeliveryDate;
  twoWeekDeliveryDate?: IPossibleDeliveryDate;
}
